import { BiEdit, BiGridVertical } from "react-icons/bi"
import { HiOutlineChevronDown } from "react-icons/hi"
import { ImAttachment } from "react-icons/im"
import { IoMdRemoveCircleOutline } from "react-icons/io"
import { IoChevronBackOutline, IoDocumentTextOutline, IoImageOutline } from "react-icons/io5"
import { RiCloseFill } from "react-icons/ri"
import { VscSmiley } from "react-icons/vsc"
import { AbsoluteContainer, AppLabel, AppLink, AppSpan, AppText, Button, Circle, CustomContainer, FixedContainer, FlexColumn, FlexRow, GridContainer, Input } from "src/style"

export const DisputeChats: React.FC<any> = ({toggleTo}) => {

    return (
        <>
            <FixedContainer left="23" top="5.7" zIndex="2" width="100" sizeUnit="%" bgColor="#ffffff" className="subheader-fix-position">
                <GridContainer height="5" leftPadding="2" rightPadding="2" 
                    style={{borderBottom: '1px solid #E2E8F0'}}
                >
                    <FlexRow>
                        <GridContainer 
                            height='3' width='3.2' borderColor=' #E4ECF7' 
                            radius='0.4' rightMargin='2'
                            onClick={() => toggleTo('disputes')}
                        >
                            <IoChevronBackOutline className='back-icon' />
                        </GridContainer>
                        <AppLabel fontWeight="600" color="#031849" topMargin="0.5">Dispute Case - CL001</AppLabel>
                    </FlexRow>
                </GridContainer>
            </FixedContainer>
            <FixedContainer 
                left="23" top="11" bgColor="#ffffff" 
                leftPadding="2" rightPadding="2"
                className="dispute-title-subheading"
            >
                <GridContainer minHeight="4">
                    <FlexRow justifyContent="space-between">
                        <AppText fontWeight="600" color="#718096">
                            Dispute: <AppSpan fontWeight="600" color="#031849">Password Reset</AppSpan>
                        </AppText>
                        <FlexRow width="auto" sizeUnit="">
                            <GridContainer 
                                height='2.4' bgColor="#E1E8FF" rightMargin="1"
                                radius='2.1' leftPadding='1.5' rightPadding='1.5'
                                width="auto" sizeUnit=""
                            >
                                <AppText textSize='1.2' fontWeight='600' color='#4C6FFF'>
                                    Open
                                </AppText>
                            </GridContainer>
                            <AppText textSize="1.2" fontWeight="600" color="#27272E">Ticket ID: #6493</AppText>
                        </FlexRow>
                    </FlexRow>
                </GridContainer>
            </FixedContainer>
            <FixedContainer 
                width="28.2" top="5.7" right="0" height="full" zIndex="2"
                topPadding="0.5" leftPadding="1" rightPadding="2"
                style={{borderLeft: '1px solid #D5D9DD'}}
            >
                <FlexRow justifyContent="space-between">
                    <AppLabel textSize="1.3" fontWeight="600" color="#031849" leftPadding="1" topPadding="1">User</AppLabel>
                    <CustomContainer width="auto" sizeUnit="">
                        <AppSpan rightMargin="1.5" textSize="1.8" ><BiEdit /></AppSpan>
                        <AppSpan textSize="2.2" hoverColor="#E4405F"><RiCloseFill /></AppSpan>
                    </CustomContainer>
                </FlexRow>
                <CustomContainer topMargin="2" overflow="auto" className="dispute-side-info-wrapper">
                    <CustomContainer 
                        bgColor="#FEFEFE" borderColor="#D5D9DD" radius="0.3"
                        minHeight="20" 
                    >
                        <GridContainer 
                            height="3.6" bgColor="#F3F5FA" leftPadding="1" rightPadding="1"
                            style={{borderBottom: '1px solid #D5D9DD'}}
                        >
                            <FlexRow justifyContent="space-between">
                                <FlexRow width="auto" sizeUnit="">
                                    <AppSpan rightMargin="0.6" textSize="1.6"><BiGridVertical /></AppSpan>
                                    <AppLabel fontWeight="600" color="#031849" topPadding="0.5">Contact Details</AppLabel>
                                </FlexRow>
                                <AppSpan><IoMdRemoveCircleOutline /></AppSpan>
                            </FlexRow>
                        </GridContainer>
                        <CustomContainer padding="1" leftPadding="1.6">
                            <CustomContainer>
                                <AppLabel textSize="1.1" color="#718096">Name</AppLabel>
                                <AppText textSize="1.2" fontWeight="600" color="#031849" topMargin="-0.3">Ridwan Kolawole</AppText>
                            </CustomContainer>
                            <CustomContainer topMargin="0.3">
                                <AppLabel textSize="1.1" color="#718096">Email</AppLabel>
                                <AppText textSize="1.2" fontWeight="600" color="#031849" topMargin="-0.3">ridwan.kolawole@gmail.com</AppText>
                            </CustomContainer>
                            <CustomContainer topMargin="0.3">
                                <AppLabel textSize="1.1" color="#718096">Phone</AppLabel>
                                <AppText textSize="1.2" fontWeight="600" color="#031849" topMargin="-0.3">08025378192</AppText>
                            </CustomContainer>
                            <CustomContainer topMargin="0.3">
                                <AppLabel textSize="1.1" color="#718096">Identifier</AppLabel>
                                <AppText textSize="1.2" fontWeight="600" color="#031849" topMargin="-0.3">Ridwan Kolawole</AppText>
                            </CustomContainer>
                        </CustomContainer>
                    </CustomContainer>
                    <CustomContainer 
                        bgColor="#FEFEFE" borderColor="#D5D9DD" radius="0.3"
                        minHeight="13.7" topMargin="1.5"
                    >
                        <GridContainer 
                            height="3.6" bgColor="#F3F5FA" leftPadding="1" rightPadding="1"
                            style={{borderBottom: '1px solid #D5D9DD'}}
                        >
                            <AppText textSize="1.3" fontWeight="700" color="#031849" width="100" sizeUnit="%">SLA - 3hrs</AppText>
                        </GridContainer>
                        <CustomContainer padding="1" leftPadding="1.6">
                           <CustomContainer>
                                <AppLabel textSize="1.1" color="#718096">First Response Due</AppLabel>
                                <FlexRow topMargin="-0.4">
                                    <Circle size="1" bgColor="#4FCB83" rightMargin="1" />
                                    <AppSpan textSize="1.1" fontWeight="600" color="#4C6FFF">by Wed, 03 Jul 2019, 10:00 AM</AppSpan>
                                </FlexRow>
                           </CustomContainer>
                           <CustomContainer topMargin="0.7">
                                <AppLabel textSize="1.1" color="#718096">
                                    Resolution Due 
                                    <AppLink 
                                        textSize="0.8" fontWeight="600" color="#031849" 
                                        hoverColor="#4C6FFF" decoration="none" leftMargin="1"
                                    >
                                        Edit
                                    </AppLink>
                                </AppLabel>
                                <FlexRow topMargin="-0.4">
                                    <Circle size="1" bgColor="#4FCB83" rightMargin="1" />
                                    <AppSpan textSize="1.1" fontWeight="600" color="#4C6FFF">by Wed, 03 Jul 2019, 10:00 AM</AppSpan>
                                </FlexRow>
                           </CustomContainer>
                        </CustomContainer>
                    </CustomContainer>
                    <CustomContainer 
                        bgColor="#FEFEFE" borderColor="#D5D9DD" radius="0.3"
                        minHeight="39.6" topMargin="1.5"
                    >
                        <GridContainer 
                            height="3.6" bgColor="#F3F5FA" leftPadding="1" rightPadding="1"
                            style={{borderBottom: '1px solid #D5D9DD'}}
                        >
                            <AppText textSize="1.3" fontWeight="700" color="#031849" width="100" sizeUnit="%">Tickets</AppText>
                        </GridContainer>
                        <CustomContainer>
                            <CustomContainer 
                                padding="1" leftPadding="1.6" rightPadding="1.5"
                                style={{borderBottom: '1px solid #D5D9DD'}}
                            >
                                <FlexRow justifyContent="space-between">
                                    <select className="hidden-dropdown">
                                        <option>Open</option>
                                        <option>Resolved</option>
                                        <option>Unresolved</option>
                                        <option>Closed</option>
                                    </select>
                                    <CustomContainer width="auto" sizeUnit="">
                                        <AppLabel textSize="1.1" color="#718096">Status</AppLabel>
                                        <AppText textSize="1.2" fontWeight="600" color="#27272E" topMargin="-0.3">Open</AppText>
                                    </CustomContainer>
                                    <AppSpan textSize="1.7"><HiOutlineChevronDown /></AppSpan>
                                </FlexRow>
                            </CustomContainer>
                            <CustomContainer 
                                padding="1" leftPadding="1.6" rightPadding="1.5"
                                style={{borderBottom: '1px solid #D5D9DD'}}
                            >
                                <FlexRow justifyContent="space-between">
                                    <select className="hidden-dropdown">
                                        <option>Customer support</option>
                                        <option>Technical support</option>
                                        <option>Risk management</option>
                                        <option>Underwriting</option>
                                    </select>
                                    <CustomContainer width="auto" sizeUnit="">
                                        <AppLabel textSize="1.1" color="#718096">Department</AppLabel>
                                        <AppText textSize="1.2" fontWeight="600" color="#27272E" topMargin="-0.3">Customer support</AppText>
                                    </CustomContainer>
                                    <AppSpan textSize="1.7"><HiOutlineChevronDown /></AppSpan>
                                </FlexRow>
                            </CustomContainer>
                            <CustomContainer 
                                padding="1" leftPadding="1.6" rightPadding="1.5"
                                style={{borderBottom: '1px solid #D5D9DD'}}
                            >
                                <FlexRow justifyContent="space-between">
                                    <select className="hidden-dropdown">
                                        <option>Ridwan Kolawole</option>
                                        <option>Chijindu Amadi</option>
                                        <option>Khaleel dalegan</option>
                                        <option>Muhammed Suleiman</option>
                                    </select>
                                    <CustomContainer width="auto" sizeUnit="">
                                        <AppLabel textSize="1.1" color="#718096">Assigned to</AppLabel>
                                        <AppText textSize="1.2" fontWeight="600" color="#27272E" topMargin="-0.3">Chijindu Amadi</AppText>
                                    </CustomContainer>
                                    <AppSpan textSize="1.7"><HiOutlineChevronDown /></AppSpan>
                                </FlexRow>
                            </CustomContainer>
                            <CustomContainer 
                                padding="1" leftPadding="1.6" rightPadding="1.5"
                                style={{borderBottom: '1px solid #D5D9DD'}}
                            >
                                <FlexRow justifyContent="space-between">
                                    <select className="hidden-dropdown">
                                        <option>High</option>
                                        <option>Medium</option>
                                        <option>Low</option>
                                    </select>
                                    <CustomContainer width="auto" sizeUnit="">
                                        <AppLabel textSize="1.1" color="#718096">Priority</AppLabel>
                                        <FlexRow width="auto" sizeUnit="" topMargin="-0.3">
                                            <CustomContainer 
                                                bgColor='#4AAE8C'
                                                radius="0.1" height='1.2' width='1.2' rightMargin='1'
                                            />
                                            <AppText textSize="1.2">Low</AppText>
                                        </FlexRow>
                                    </CustomContainer>
                                    <AppSpan textSize="1.7"><HiOutlineChevronDown /></AppSpan>
                                </FlexRow>
                            </CustomContainer>
                            <CustomContainer 
                                padding="1" leftPadding="1.6" rightPadding="1.5"
                                style={{borderBottom: '1px solid #D5D9DD'}}
                            >
                                <FlexRow justifyContent="space-between">
                                    <select className="hidden-dropdown">
                                        <option>View</option>
                                        <option>Mark as resolved</option>
                                        <option>Unmarked as resolved</option>
                                    </select>
                                    <CustomContainer width="auto" sizeUnit="">
                                        <AppLabel textSize="1.1" color="#718096">Type</AppLabel>
                                        <AppText textSize="1.2" fontWeight="600" color="#27272E" topMargin="-0.3">Bug</AppText>
                                    </CustomContainer>
                                    <AppSpan textSize="1.7"><HiOutlineChevronDown /></AppSpan>
                                </FlexRow>
                            </CustomContainer>
                            <CustomContainer 
                                padding="1" leftPadding="1.6" rightPadding="1.5"
                            >
                                <FlexRow justifyContent="space-between">
                                    <select className="hidden-dropdown">
                                        <option>View</option>
                                        <option>Mark as resolved</option>
                                        <option>Unmarked as resolved</option>
                                    </select>
                                    <CustomContainer width="auto" sizeUnit="">
                                        <AppLabel textSize="1.1" color="#718096">Tag</AppLabel>
                                        <AppText textSize="1.2" topMargin="-0.3">Add tag</AppText>
                                    </CustomContainer>
                                    <AppSpan textSize="1.7"><HiOutlineChevronDown /></AppSpan>
                                </FlexRow>
                            </CustomContainer>
                        </CustomContainer>
                    </CustomContainer>
                </CustomContainer>
            </FixedContainer>
            <CustomContainer rightPadding="28.2" topMargin="11">
                <CustomContainer topPadding="2" bottomPadding="18" overflow="auto">
                    <FlexColumn justifyContent="flex-start" alignItems="flex-start" topMargin="2">
                        <CustomContainer maxWidth="40" padding="1.2" bgColor="#E1E8FF" radius="0.5">
                            <AppText textSize="1.2">
                                Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod 
                                tempor incididunt ut labore et dolore magna aliqua. Ut enim ad 
                            </AppText>
                        </CustomContainer>
                        <AppSpan textSize="1" fontWeight="500" topMargin="1">2 hours ago</AppSpan>
                    </FlexColumn>
                    <FlexColumn justifyContent="flex-start" alignItems="flex-end" topMargin="2">
                        <CustomContainer maxWidth="40" padding="1.2" bgColor="#F7FAFC" radius="0.5">
                            <AppText textSize="1.2">
                                Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod 
                                tempor incididunt ut labore et dolore magna aliqua. Ut enim ad 
                            </AppText>
                        </CustomContainer>
                        <AppSpan textSize="1" fontWeight="500" topMargin="1">2 hours ago</AppSpan>
                    </FlexColumn>
                    <FlexColumn justifyContent="flex-start" alignItems="flex-start" topMargin="2">
                        <CustomContainer maxWidth="40" padding="1.2" bgColor="#E1E8FF" radius="0.5">
                            <AppText textSize="1.2">
                                Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod 
                                tempor incididunt ut labore et dolore magna aliqua. Ut enim ad 
                            </AppText>
                        </CustomContainer>
                        <AppSpan textSize="1" fontWeight="500" topMargin="1">2 hours ago</AppSpan>
                    </FlexColumn>
                    <FlexColumn justifyContent="flex-start" alignItems="flex-end" topMargin="2">
                        <CustomContainer maxWidth="40" padding="1.2" bgColor="#F7FAFC" radius="0.5">
                            <AppText textSize="1.2">
                                Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod 
                                tempor incididunt ut labore et dolore magna aliqua. Ut enim ad 
                            </AppText>
                        </CustomContainer>
                        <AppSpan textSize="1" fontWeight="500" topMargin="1">2 hours ago</AppSpan>
                    </FlexColumn>
                    <FlexColumn justifyContent="flex-start" alignItems="flex-end" topMargin="2">
                        <CustomContainer maxWidth="40" padding="1.2" bgColor="#F7FAFC" radius="0.5">
                            <AppText textSize="1.2">
                                Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod 
                                tempor incididunt ut labore et dolore magna aliqua. Ut enim ad 
                            </AppText>
                        </CustomContainer>
                        <AppSpan textSize="1" fontWeight="500" topMargin="1">2 hours ago</AppSpan>
                    </FlexColumn>
                    <FlexColumn justifyContent="flex-start" alignItems="flex-start" topMargin="2">
                        <CustomContainer maxWidth="40" padding="1.2" bgColor="#E1E8FF" radius="0.5">
                            <AppText textSize="1.2">
                                Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod 
                                tempor incididunt ut labore et dolore magna aliqua. Ut enim ad 
                            </AppText>
                        </CustomContainer>
                        <AppSpan textSize="1" fontWeight="500" topMargin="1">2 hours ago</AppSpan>
                    </FlexColumn>
                </CustomContainer>
            </CustomContainer>
            <FixedContainer className="conversation-chat-fix-position" bottom="1" left="25.5" bgColor="#ffffff">
                <CustomContainer height="15.8"  radius="0.6" borderColor="#D3D8DD" topMargin="2">
                    <Input 
                        textSize="1.2" color="#031849" 
                        style={{borderBottom: '1px solid #D3D8DD'}}
                        rightPadding="1" leftPadding="1" height="3.7" 
                        placeholder="Reply"
                    />
                    <AbsoluteContainer bottom="0" left="0" width="100" sizeUnit="%">
                        <FlexRow justifyContent="space-between" leftPadding="1.5" rightPadding="1.5" bottomPadding="1">
                            <FlexRow width="auto" sizeUnit="" rightMargin="2" gap="2">
                                <VscSmiley className="chat-input-icons" />
                                <IoImageOutline className="chat-input-icons" />
                                <ImAttachment className="chat-input-icons" />
                                <IoDocumentTextOutline className="chat-input-icons" />
                            </FlexRow>
                            <Button
                                width='5.7' borderColor='#4C6FFF' height='2.6'
                                hoverBgColor='#ffffff' hoverColor='#4C6FFF' 
                                radius="0.4" titleSize="1.1"
                            >
                                Send
                            </Button>
                        </FlexRow>
                    </AbsoluteContainer>
                </CustomContainer>
            </FixedContainer>
        </>
    )
}